import React, { Component } from 'react'
import { connect } from 'react-redux'
import {getFormattedTime, docStatusToString} from '../../../util/displayUtils.js';
import { Link } from 'react-router-dom'

class AdminDashboardMenu extends Component {
    constructor(props) {
        super(props);
    }
    render() {
    return(
    <div className="admin-options-wrapper">
        <Link to="/admindashboard/"><div className="admin-options-button">Papers</div></Link>
        <Link to="/admindashboard/students"><div className="admin-options-button">Students</div></Link>
        <Link to="/admindashboard/users"><div className="admin-options-button">Editors</div></Link>
        <Link to="/admindashboard/affiliates"><div className="admin-options-button">Affiliates</div></Link>
        <Link to="/admindashboard/coupons"><div className="admin-options-button">Coupons</div></Link>
    </div>)
    }
}
export default AdminDashboardMenu;


// WEBPACK FOOTER //
// ./src/components/dashboards/AdminDashboard/AdminDashboardMenu.js